export default [
  {
    'en-US': 'Andorra',
    'zh-CN': '安道尔',
    'country_code': 'AD',
    'phone_code': '376'
  },
  {
    'en-US': 'United Arab Emirates',
    'zh-CN': '阿拉伯联合酋长国',
    'country_code': 'AE',
    'phone_code': '971'
  },
  {
    'en-US': 'Afghanistan',
    'zh-CN': '阿富汗',
    'country_code': 'AF',
    'phone_code': '93'
  },
  {
    'en-US': 'Antigua and Barbuda',
    'zh-CN': '安提瓜和巴布达',
    'country_code': 'AG',
    'phone_code': '1268'
  },
  {
    'en-US': 'Anguilla',
    'zh-CN': '安圭拉',
    'country_code': 'AI',
    'phone_code': '1264'
  },
  {
    'en-US': 'Albania',
    'zh-CN': '阿尔巴尼亚',
    'country_code': 'AL',
    'phone_code': '355'
  },
  {
    'en-US': 'Armenia',
    'zh-CN': '亚美尼亚',
    'country_code': 'AM',
    'phone_code': '374'
  },
  {
    'en-US': 'Angola',
    'zh-CN': '安哥拉',
    'country_code': 'AO',
    'phone_code': '244'
  },
  {
    'en-US': 'Argentina',
    'zh-CN': '阿根廷',
    'country_code': 'AR',
    'phone_code': '54'
  },
  {
    'en-US': 'American Samoa',
    'zh-CN': '美属萨摩亚',
    'country_code': 'AS',
    'phone_code': '1684'
  },
  {
    'en-US': 'Austria',
    'zh-CN': '奥地利',
    'country_code': 'AT',
    'phone_code': '43'
  },
  {
    'en-US': 'Australia',
    'zh-CN': '澳大利亚',
    'country_code': 'AU',
    'phone_code': '61'
  },
  {
    'en-US': 'Aruba',
    'zh-CN': '阿鲁巴',
    'country_code': 'AW',
    'phone_code': '297'
  },
  {
    'en-US': 'Azerbaijan',
    'zh-CN': '阿塞拜疆',
    'country_code': 'AZ',
    'phone_code': '994'
  },
  {
    'en-US': 'Bosniaand Herzegovina',
    'zh-CN': '波斯尼亚和黑塞哥维那',
    'country_code': 'BA',
    'phone_code': '387'
  },
  {
    'en-US': 'Barbados',
    'zh-CN': '巴巴多斯',
    'country_code': 'BB',
    'phone_code': '1246'
  },
  {
    'en-US': 'Bangladesh',
    'zh-CN': '孟加拉国',
    'country_code': 'BD',
    'phone_code': '880'
  },
  {
    'en-US': 'Belgium',
    'zh-CN': '比利时',
    'country_code': 'BE',
    'phone_code': '32'
  },
  {
    'en-US': 'Burkina Faso',
    'zh-CN': '布基纳法索',
    'country_code': 'BF',
    'phone_code': '226'
  },
  {
    'en-US': 'Bulgaria',
    'zh-CN': '保加利亚',
    'country_code': 'BG',
    'phone_code': '359'
  },
  {
    'en-US': 'Bahrain',
    'zh-CN': '巴林',
    'country_code': 'BH',
    'phone_code': '973'
  },
  {
    'en-US': 'Burundi',
    'zh-CN': '布隆迪',
    'country_code': 'BI',
    'phone_code': '257'
  },
  {
    'en-US': 'Benin',
    'zh-CN': '贝宁',
    'country_code': 'BJ',
    'phone_code': '229'
  },
  {
    'en-US': 'Bermuda',
    'zh-CN': '百慕大群岛',
    'country_code': 'BM',
    'phone_code': '1441'
  },
  {
    'en-US': 'Brunei',
    'zh-CN': '文莱',
    'country_code': 'BN',
    'phone_code': '673'
  },
  {
    'en-US': 'Bolivia',
    'zh-CN': '玻利维亚',
    'country_code': 'BO',
    'phone_code': '591'
  },
  {
    'en-US': 'Caribisch Nederland',
    'zh-CN': '荷兰加勒比',
    'country_code': 'BQ',
    'phone_code': '599'
  },
  {
    'en-US': 'Brazil',
    'zh-CN': '巴西',
    'country_code': 'BR',
    'phone_code': '55'
  },
  {
    'en-US': 'Bahamas',
    'zh-CN': '巴哈马',
    'country_code': 'BS',
    'phone_code': '1242'
  },
  {
    'en-US': 'Bhutan',
    'zh-CN': '不丹',
    'country_code': 'BT',
    'phone_code': '975'
  },
  {
    'en-US': 'Botswana',
    'zh-CN': '博茨瓦纳',
    'country_code': 'BW',
    'phone_code': '267'
  },
  {
    'en-US': 'Belarus',
    'zh-CN': '白俄罗斯',
    'country_code': 'BY',
    'phone_code': '375'
  },
  {
    'en-US': 'Belize',
    'zh-CN': '伯利兹',
    'country_code': 'BZ',
    'phone_code': '501'
  },
  {
    'en-US': 'Canada',
    'zh-CN': '加拿大',
    'country_code': 'CA',
    'phone_code': '1'
  },
  {
    'en-US': 'Democratic Republic of theCongo',
    'zh-CN': '刚果民主共和国',
    'country_code': 'CD',
    'phone_code': '243'
  },
  {
    'en-US': 'Central African Republic',
    'zh-CN': '中非共和国',
    'country_code': 'CF',
    'phone_code': '236'
  },
  {
    'en-US': 'Republic Of The Congo',
    'zh-CN': '刚果共和国',
    'country_code': 'CG',
    'phone_code': '242'
  },
  {
    'en-US': 'Switzerland',
    'zh-CN': '瑞士',
    'country_code': 'CH',
    'phone_code': '41'
  },
  {
    'en-US': 'Ivory Coast',
    'zh-CN': '象牙海岸',
    'country_code': 'CI',
    'phone_code': '225'
  },
  {
    'en-US': 'Cook Islands',
    'zh-CN': '库克群岛',
    'country_code': 'CK',
    'phone_code': '682'
  },
  {
    'en-US': 'Chile',
    'zh-CN': '智利',
    'country_code': 'CL',
    'phone_code': '56'
  },
  {
    'en-US': 'Cameroon',
    'zh-CN': '喀麦隆',
    'country_code': 'CM',
    'phone_code': '237'
  },
  {
    'en-US': 'China',
    'zh-CN': '中国',
    'country_code': 'CN',
    'phone_code': '86'
  },
  {
    'en-US': 'Colombia',
    'zh-CN': '哥伦比亚',
    'country_code': 'CO',
    'phone_code': '57'
  },
  {
    'en-US': 'CostaRica',
    'zh-CN': '哥斯达黎加',
    'country_code': 'CR',
    'phone_code': '506'
  },
  {
    'en-US': 'Cuba',
    'zh-CN': '古巴',
    'country_code': 'CU',
    'phone_code': '53'
  },
  {
    'en-US': 'Cape Verde',
    'zh-CN': '开普',
    'country_code': 'CV',
    'phone_code': '238'
  },
  {
    'en-US': 'Curacao',
    'zh-CN': '库拉索',
    'country_code': 'CW',
    'phone_code': '599'
  },
  {
    'en-US': 'Cyprus',
    'zh-CN': '塞浦路斯',
    'country_code': 'CY',
    'phone_code': '357'
  },
  {
    'en-US': 'Czech',
    'zh-CN': '捷克',
    'country_code': 'CZ',
    'phone_code': '420'
  },
  {
    'en-US': 'Germany',
    'zh-CN': '德国',
    'country_code': 'DE',
    'phone_code': '49'
  },
  {
    'en-US': 'Djibouti',
    'zh-CN': '吉布提',
    'country_code': 'DJ',
    'phone_code': '253'
  },
  {
    'en-US': 'Denmark',
    'zh-CN': '丹麦',
    'country_code': 'DK',
    'phone_code': '45'
  },
  {
    'en-US': 'Dominica',
    'zh-CN': '多米尼加',
    'country_code': 'DM',
    'phone_code': '1767'
  },
  {
    'en-US': 'dominican republic',
    'zh-CN': '多米尼加共和国',
    'country_code': 'DO',
    'phone_code': '1809'
  },
  {
    'en-US': 'Algeria',
    'zh-CN': '阿尔及利亚',
    'country_code': 'DZ',
    'phone_code': '213'
  },
  {
    'en-US': 'Ecuador',
    'zh-CN': '厄瓜多尔',
    'country_code': 'EC',
    'phone_code': '593'
  },
  {
    'en-US': 'Estonia',
    'zh-CN': '爱沙尼亚',
    'country_code': 'EE',
    'phone_code': '372'
  },
  {
    'en-US': 'Egypt',
    'zh-CN': '埃及',
    'country_code': 'EG',
    'phone_code': '20'
  },
  {
    'en-US': 'Eritrea',
    'zh-CN': '厄立特里亚',
    'country_code': 'ER',
    'phone_code': '291'
  },
  {
    'en-US': 'Spain',
    'zh-CN': '西班牙',
    'country_code': 'ES',
    'phone_code': '34'
  },
  {
    'en-US': 'Ethiopia',
    'zh-CN': '埃塞俄比亚',
    'country_code': 'ET',
    'phone_code': '251'
  },
  {
    'en-US': 'Finland',
    'zh-CN': '芬兰',
    'country_code': 'FI',
    'phone_code': '358'
  },
  {
    'en-US': 'Fiji',
    'zh-CN': '斐济',
    'country_code': 'FJ',
    'phone_code': '679'
  },
  {
    'en-US': 'Micronesia',
    'zh-CN': '密克罗尼西亚',
    'country_code': 'FM',
    'phone_code': '691'
  },
  {
    'en-US': 'Faroe Islands',
    'zh-CN': '法罗群岛',
    'country_code': 'FO',
    'phone_code': '298'
  },
  {
    'en-US': 'France',
    'zh-CN': '法国',
    'country_code': 'FR',
    'phone_code': '33'
  },
  {
    'en-US': 'Gabon',
    'zh-CN': '加蓬',
    'country_code': 'GA',
    'phone_code': '241'
  },
  {
    'en-US': 'United Kingdom',
    'zh-CN': '英国',
    'country_code': 'GB',
    'phone_code': '44'
  },
  {
    'en-US': 'Grenada',
    'zh-CN': '格林纳达',
    'country_code': 'GD',
    'phone_code': '1473'
  },
  {
    'en-US': 'Georgia',
    'zh-CN': '格鲁吉亚',
    'country_code': 'GE',
    'phone_code': '995'
  },
  {
    'en-US': 'French Guiana',
    'zh-CN': '法属圭亚那',
    'country_code': 'GF',
    'phone_code': '594'
  },
  {
    'en-US': 'Ghana',
    'zh-CN': '加纳',
    'country_code': 'GH',
    'phone_code': '233'
  },
  {
    'en-US': 'Gibraltar',
    'zh-CN': '直布罗陀',
    'country_code': 'GI',
    'phone_code': '350'
  },
  {
    'en-US': 'Greenland',
    'zh-CN': '格陵兰岛',
    'country_code': 'GL',
    'phone_code': '299'
  },
  {
    'en-US': 'Gambia',
    'zh-CN': '冈比亚',
    'country_code': 'GM',
    'phone_code': '220'
  },
  {
    'en-US': 'Guinea',
    'zh-CN': '几内亚',
    'country_code': 'GN',
    'phone_code': '224'
  },
  {
    'en-US': 'Guadeloupe',
    'zh-CN': '瓜德罗普岛',
    'country_code': 'GP',
    'phone_code': '590'
  },
  {
    'en-US': 'Equatorial Guinea',
    'zh-CN': '赤道几内亚',
    'country_code': 'GQ',
    'phone_code': '240'
  },
  {
    'en-US': 'Greece',
    'zh-CN': '希腊',
    'country_code': 'GR',
    'phone_code': '30'
  },
  {
    'en-US': 'Guatemala',
    'zh-CN': '瓜地马拉',
    'country_code': 'GT',
    'phone_code': '502'
  },
  {
    'en-US': 'Guam',
    'zh-CN': '关岛',
    'country_code': 'GU',
    'phone_code': '1671'
  },
  {
    'en-US': 'Guinea-Bissau',
    'zh-CN': '几内亚比绍共和国',
    'country_code': 'GW',
    'phone_code': '245'
  },
  {
    'en-US': 'Guyana',
    'zh-CN': '圭亚那',
    'country_code': 'GY',
    'phone_code': '592'
  },
  {
    'en-US': 'Hong Kong',
    'zh-CN': '中国香港',
    'country_code': 'HK',
    'phone_code': '852'
  },
  {
    'en-US': 'Honduras',
    'zh-CN': '洪都拉斯',
    'country_code': 'HN',
    'phone_code': '504'
  },
  {
    'en-US': 'Croatia',
    'zh-CN': '克罗地亚',
    'country_code': 'HR',
    'phone_code': '385'
  },
  {
    'en-US': 'Haiti',
    'zh-CN': '海地',
    'country_code': 'HT',
    'phone_code': '509'
  },
  {
    'en-US': 'Hungary',
    'zh-CN': '匈牙利',
    'country_code': 'HU',
    'phone_code': '36'
  },
  {
    'en-US': 'Indonesia',
    'zh-CN': '印度尼西亚',
    'country_code': 'ID',
    'phone_code': '62'
  },
  {
    'en-US': 'Ireland',
    'zh-CN': '爱尔兰',
    'country_code': 'IE',
    'phone_code': '353'
  },
  {
    'en-US': 'Israel',
    'zh-CN': '以色列',
    'country_code': 'IL',
    'phone_code': '972'
  },
  {
    'en-US': 'India',
    'zh-CN': '印度',
    'country_code': 'IN',
    'phone_code': '91'
  },
  {
    'en-US': 'Iraq',
    'zh-CN': '伊拉克',
    'country_code': 'IQ',
    'phone_code': '964'
  },
  {
    'en-US': 'Iran',
    'zh-CN': '伊朗',
    'country_code': 'IR',
    'phone_code': '98'
  },
  {
    'en-US': 'Iceland',
    'zh-CN': '冰岛',
    'country_code': 'IS',
    'phone_code': '354'
  },
  {
    'en-US': 'Italy',
    'zh-CN': '意大利',
    'country_code': 'IT',
    'phone_code': '39'
  },
  {
    'en-US': 'Jamaica',
    'zh-CN': '牙买加',
    'country_code': 'JM',
    'phone_code': '1876'
  },
  {
    'en-US': 'Jordan',
    'zh-CN': '约旦',
    'country_code': 'JO',
    'phone_code': '962'
  },
  {
    'en-US': 'Japan',
    'zh-CN': '日本',
    'country_code': 'JP',
    'phone_code': '81'
  },
  {
    'en-US': 'Kenya',
    'zh-CN': '肯尼亚',
    'country_code': 'KE',
    'phone_code': '254'
  },
  {
    'en-US': 'Kyrgyzstan',
    'zh-CN': '吉尔吉斯斯坦',
    'country_code': 'KG',
    'phone_code': '996'
  },
  {
    'en-US': 'Cambodia',
    'zh-CN': '柬埔寨',
    'country_code': 'KH',
    'phone_code': '855'
  },
  {
    'en-US': 'Kiribati',
    'zh-CN': '基里巴斯',
    'country_code': 'KI',
    'phone_code': '686'
  },
  {
    'en-US': 'Comoros',
    'zh-CN': '科摩罗',
    'country_code': 'KM',
    'phone_code': '269'
  },
  {
    'en-US': 'Saint Kitts and Nevis',
    'zh-CN': '圣基茨和尼维斯',
    'country_code': 'KN',
    'phone_code': '1869'
  },
  {
    'en-US': 'Korea Democratic Rep.',
    'zh-CN': '朝鲜',
    'country_code': 'KP',
    'phone_code': '850'
  },
  {
    'en-US': 'South Korea',
    'zh-CN': '韩国',
    'country_code': 'KR',
    'phone_code': '82'
  },
  {
    'en-US': 'Kuwait',
    'zh-CN': '科威特',
    'country_code': 'KW',
    'phone_code': '965'
  },
  {
    'en-US': 'Cayman Islands',
    'zh-CN': '开曼群岛',
    'country_code': 'KY',
    'phone_code': '1345'
  },
  {
    'en-US': 'Kazakhstan',
    'zh-CN': '哈萨克斯坦',
    'country_code': 'KZ',
    'phone_code': '7'
  },
  {
    'en-US': 'Laos',
    'zh-CN': '老挝',
    'country_code': 'LA',
    'phone_code': '856'
  },
  {
    'en-US': 'Lebanon',
    'zh-CN': '黎巴嫩',
    'country_code': 'LB',
    'phone_code': '961'
  },
  {
    'en-US': 'Saint Lucia',
    'zh-CN': '圣露西亚',
    'country_code': 'LC',
    'phone_code': '1758'
  },
  {
    'en-US': 'Liechtenstein',
    'zh-CN': '列支敦士登',
    'country_code': 'LI',
    'phone_code': '423'
  },
  {
    'en-US': 'Sri Lanka',
    'zh-CN': '斯里兰卡',
    'country_code': 'LK',
    'phone_code': '94'
  },
  {
    'en-US': 'Liberia',
    'zh-CN': '利比里亚',
    'country_code': 'LR',
    'phone_code': '231'
  },
  {
    'en-US': 'Lesotho',
    'zh-CN': '莱索托',
    'country_code': 'LS',
    'phone_code': '266'
  },
  {
    'en-US': 'Lithuania',
    'zh-CN': '立陶宛',
    'country_code': 'LT',
    'phone_code': '370'
  },
  {
    'en-US': 'Luxembourg',
    'zh-CN': '卢森堡',
    'country_code': 'LU',
    'phone_code': '352'
  },
  {
    'en-US': 'Latvia',
    'zh-CN': '拉脱维亚',
    'country_code': 'LV',
    'phone_code': '371'
  },
  {
    'en-US': 'Libya',
    'zh-CN': '利比亚',
    'country_code': 'LY',
    'phone_code': '218'
  },
  {
    'en-US': 'Morocco',
    'zh-CN': '摩洛哥',
    'country_code': 'MA',
    'phone_code': '212'
  },
  {
    'en-US': 'Monaco',
    'zh-CN': '摩纳哥',
    'country_code': 'MC',
    'phone_code': '377'
  },
  {
    'en-US': 'Moldova',
    'zh-CN': '摩尔多瓦',
    'country_code': 'MD',
    'phone_code': '373'
  },
  {
    'en-US': 'Montenegro',
    'zh-CN': '黑山',
    'country_code': 'ME',
    'phone_code': '382'
  },
  {
    'en-US': 'Madagascar',
    'zh-CN': '马达加斯加',
    'country_code': 'MG',
    'phone_code': '261'
  },
  {
    'en-US': 'Marshall Islands',
    'zh-CN': '马绍尔群岛',
    'country_code': 'MH',
    'phone_code': '692'
  },
  {
    'en-US': 'Macedonia',
    'zh-CN': '马其顿',
    'country_code': 'MK',
    'phone_code': '389'
  },
  {
    'en-US': 'Mali',
    'zh-CN': '马里',
    'country_code': 'ML',
    'phone_code': '223'
  },
  {
    'en-US': 'Myanmar',
    'zh-CN': '缅甸',
    'country_code': 'MM',
    'phone_code': '95'
  },
  {
    'en-US': 'Mongolia',
    'zh-CN': '蒙古',
    'country_code': 'MN',
    'phone_code': '976'
  },
  {
    'en-US': 'Macau',
    'zh-CN': '中国澳门',
    'country_code': 'MO',
    'phone_code': '853'
  },
  {
    'en-US': 'Mauritania',
    'zh-CN': '毛里塔尼亚',
    'country_code': 'MR',
    'phone_code': '222'
  },
  {
    'en-US': 'Montserrat',
    'zh-CN': '蒙特塞拉特岛',
    'country_code': 'MS',
    'phone_code': '1664'
  },
  {
    'en-US': 'Malta',
    'zh-CN': '马耳他',
    'country_code': 'MT',
    'phone_code': '356'
  },
  {
    'en-US': 'Mauritius',
    'zh-CN': '毛里求斯',
    'country_code': 'MU',
    'phone_code': '230'
  },
  {
    'en-US': 'Maldives',
    'zh-CN': '马尔代夫',
    'country_code': 'MV',
    'phone_code': '960'
  },
  {
    'en-US': 'Malawi',
    'zh-CN': '马拉维',
    'country_code': 'MW',
    'phone_code': '265'
  },
  {
    'en-US': 'Mexico',
    'zh-CN': '墨西哥',
    'country_code': 'MX',
    'phone_code': '52'
  },
  {
    'en-US': 'Malaysia',
    'zh-CN': '马来西亚',
    'country_code': 'MY',
    'phone_code': '60'
  },
  {
    'en-US': 'Mozambique',
    'zh-CN': '莫桑比克',
    'country_code': 'MZ',
    'phone_code': '258'
  },
  {
    'en-US': 'Namibia',
    'zh-CN': '纳米比亚',
    'country_code': 'NA',
    'phone_code': '264'
  },
  {
    'en-US': 'New Caledonia',
    'zh-CN': '新喀里多尼亚',
    'country_code': 'NC',
    'phone_code': '687'
  },
  {
    'en-US': 'Niger',
    'zh-CN': '尼日尔',
    'country_code': 'NE',
    'phone_code': '227'
  },
  {
    'en-US': 'Nigeria',
    'zh-CN': '尼日利亚',
    'country_code': 'NG',
    'phone_code': '234'
  },
  {
    'en-US': 'Nicaragua',
    'zh-CN': '尼加拉瓜',
    'country_code': 'NI',
    'phone_code': '505'
  },
  {
    'en-US': 'Netherlands',
    'zh-CN': '荷兰',
    'country_code': 'NL',
    'phone_code': '31'
  },
  {
    'en-US': 'Norway',
    'zh-CN': '挪威',
    'country_code': 'NO',
    'phone_code': '47'
  },
  {
    'en-US': 'Nepal',
    'zh-CN': '尼泊尔',
    'country_code': 'NP',
    'phone_code': '977'
  },
  {
    'en-US': 'Nauru',
    'zh-CN': '拿鲁岛',
    'country_code': 'NR',
    'phone_code': '674'
  },
  {
    'en-US': 'New Zealand',
    'zh-CN': '新西兰',
    'country_code': 'NZ',
    'phone_code': '64'
  },
  {
    'en-US': 'Oman',
    'zh-CN': '阿曼',
    'country_code': 'OM',
    'phone_code': '968'
  },
  {
    'en-US': 'Panama',
    'zh-CN': '巴拿马',
    'country_code': 'PA',
    'phone_code': '507'
  },
  {
    'en-US': 'Peru',
    'zh-CN': '秘鲁',
    'country_code': 'PE',
    'phone_code': '51'
  },
  {
    'en-US': 'French Polynesia',
    'zh-CN': '法属波利尼西亚',
    'country_code': 'PF',
    'phone_code': '689'
  },
  {
    'en-US': 'Papua New Guinea',
    'zh-CN': '巴布亚新几内亚',
    'country_code': 'PG',
    'phone_code': '675'
  },
  {
    'en-US': 'Philippines',
    'zh-CN': '菲律宾',
    'country_code': 'PH',
    'phone_code': '63'
  },
  {
    'en-US': 'Pakistan',
    'zh-CN': '巴基斯坦',
    'country_code': 'PK',
    'phone_code': '92'
  },
  {
    'en-US': 'Poland',
    'zh-CN': '波兰',
    'country_code': 'PL',
    'phone_code': '48'
  },
  {
    'en-US': 'Saint Pierreand Miquelon',
    'zh-CN': '圣彼埃尔和密克隆岛',
    'country_code': 'PM',
    'phone_code': '508'
  },
  {
    'en-US': 'Puerto Rico',
    'zh-CN': '波多黎各',
    'country_code': 'PR',
    'phone_code': '1787'
  },
  {
    'en-US': 'Portugal',
    'zh-CN': '葡萄牙',
    'country_code': 'PT',
    'phone_code': '351'
  },
  {
    'en-US': 'Palau',
    'zh-CN': '帕劳',
    'country_code': 'PW',
    'phone_code': '680'
  },
  {
    'en-US': 'Paraguay',
    'zh-CN': '巴拉圭',
    'country_code': 'PY',
    'phone_code': '595'
  },
  {
    'en-US': 'Qatar',
    'zh-CN': '卡塔尔',
    'country_code': 'QA',
    'phone_code': '974'
  },
  {
    'en-US': 'Réunion Island',
    'zh-CN': '留尼汪',
    'country_code': 'RE',
    'phone_code': '262'
  },
  {
    'en-US': 'Romania',
    'zh-CN': '罗马尼亚',
    'country_code': 'RO',
    'phone_code': '40'
  },
  {
    'en-US': 'Serbia',
    'zh-CN': '塞尔维亚',
    'country_code': 'RS',
    'phone_code': '381'
  },
  {
    'en-US': 'Russia',
    'zh-CN': '俄罗斯',
    'country_code': 'RU',
    'phone_code': '7'
  },
  {
    'en-US': 'Rwanda',
    'zh-CN': '卢旺达',
    'country_code': 'RW',
    'phone_code': '250'
  },
  {
    'en-US': 'Saudi Arabia',
    'zh-CN': '沙特阿拉伯',
    'country_code': 'SA',
    'phone_code': '966'
  },
  {
    'en-US': 'Solomon Islands',
    'zh-CN': '所罗门群岛',
    'country_code': 'SB',
    'phone_code': '677'
  },
  {
    'en-US': 'Seychelles',
    'zh-CN': '塞舌尔',
    'country_code': 'SC',
    'phone_code': '248'
  },
  {
    'en-US': 'Sudan',
    'zh-CN': '苏丹',
    'country_code': 'SD',
    'phone_code': '249'
  },
  {
    'en-US': 'Sweden',
    'zh-CN': '瑞典',
    'country_code': 'SE',
    'phone_code': '46'
  },
  {
    'en-US': 'Singapore',
    'zh-CN': '新加坡',
    'country_code': 'SG',
    'phone_code': '65'
  },
  {
    'en-US': 'Slovenia',
    'zh-CN': '斯洛文尼亚',
    'country_code': 'SI',
    'phone_code': '386'
  },
  {
    'en-US': 'Slovakia',
    'zh-CN': '斯洛伐克',
    'country_code': 'SK',
    'phone_code': '421'
  },
  {
    'en-US': 'Sierra Leone',
    'zh-CN': '塞拉利昂',
    'country_code': 'SL',
    'phone_code': '232'
  },
  {
    'en-US': 'San Marino',
    'zh-CN': '圣马力诺',
    'country_code': 'SM',
    'phone_code': '378'
  },
  {
    'en-US': 'Senegal',
    'zh-CN': '塞内加尔',
    'country_code': 'SN',
    'phone_code': '221'
  },
  {
    'en-US': 'Somalia',
    'zh-CN': '索马里',
    'country_code': 'SO',
    'phone_code': '252'
  },
  {
    'en-US': 'Suriname',
    'zh-CN': '苏里南',
    'country_code': 'SR',
    'phone_code': '597'
  },
  {
    'en-US': 'Sao Tome and Principe',
    'zh-CN': '圣多美和普林西比',
    'country_code': 'ST',
    'phone_code': '239'
  },
  {
    'en-US': 'ElSalvador',
    'zh-CN': '萨尔瓦多',
    'country_code': 'SV',
    'phone_code': '503'
  },
  {
    'en-US': 'Syria',
    'zh-CN': '叙利亚',
    'country_code': 'SY',
    'phone_code': '963'
  },
  {
    'en-US': 'Swaziland',
    'zh-CN': '斯威士兰',
    'country_code': 'SZ',
    'phone_code': '268'
  },
  {
    'en-US': 'Turksand Caicos Islands',
    'zh-CN': '特克斯和凯科斯群岛',
    'country_code': 'TC',
    'phone_code': '1649'
  },
  {
    'en-US': 'Chad',
    'zh-CN': '乍得',
    'country_code': 'TD',
    'phone_code': '235'
  },
  {
    'en-US': 'Togo',
    'zh-CN': '多哥',
    'country_code': 'TG',
    'phone_code': '228'
  },
  {
    'en-US': 'Thailand',
    'zh-CN': '泰国',
    'country_code': 'TH',
    'phone_code': '66'
  },
  {
    'en-US': 'Tajikistan',
    'zh-CN': '塔吉克斯坦',
    'country_code': 'TJ',
    'phone_code': '992'
  },
  {
    'en-US': 'East Timor',
    'zh-CN': '东帝汶',
    'country_code': 'TL',
    'phone_code': '670'
  },
  {
    'en-US': 'Turkmenistan',
    'zh-CN': '土库曼斯坦',
    'country_code': 'TM',
    'phone_code': '993'
  },
  {
    'en-US': 'Tunisia',
    'zh-CN': '突尼斯',
    'country_code': 'TN',
    'phone_code': '216'
  },
  {
    'en-US': 'Tonga',
    'zh-CN': '汤加',
    'country_code': 'TO',
    'phone_code': '676'
  },
  {
    'en-US': 'Turkey',
    'zh-CN': '土耳其',
    'country_code': 'TR',
    'phone_code': '90'
  },
  {
    'en-US': 'Trinidadand Tobago',
    'zh-CN': '特立尼达和多巴哥',
    'country_code': 'TT',
    'phone_code': '1868'
  },
  {
    'en-US': 'Taiwan',
    'zh-CN': '中国台湾',
    'country_code': 'TW',
    'phone_code': '886'
  },
  {
    'en-US': 'Tanzania',
    'zh-CN': '坦桑尼亚',
    'country_code': 'TZ',
    'phone_code': '255'
  },
  {
    'en-US': 'Ukraine',
    'zh-CN': '乌克兰',
    'country_code': 'UA',
    'phone_code': '380'
  },
  {
    'en-US': 'Uganda',
    'zh-CN': '乌干达',
    'country_code': 'UG',
    'phone_code': '256'
  },
  {
    'en-US': 'United States',
    'zh-CN': '美国',
    'country_code': 'US',
    'phone_code': '1'
  },
  {
    'en-US': 'Uruguay',
    'zh-CN': '乌拉圭',
    'country_code': 'UY',
    'phone_code': '598'
  },
  {
    'en-US': 'Uzbekistan',
    'zh-CN': '乌兹别克斯坦',
    'country_code': 'UZ',
    'phone_code': '998'
  },
  {
    'en-US': 'Saint Vincent and The Grenadines',
    'zh-CN': '圣文森特和格林纳丁斯',
    'country_code': 'VC',
    'phone_code': '1784'
  },
  {
    'en-US': 'Venezuela',
    'zh-CN': '委内瑞拉',
    'country_code': 'VE',
    'phone_code': '58'
  },
  {
    'en-US': 'VirginIslands,British',
    'zh-CN': '英属处女群岛',
    'country_code': 'VG',
    'phone_code': '1284'
  },
  {
    'en-US': 'Vietnam',
    'zh-CN': '越南',
    'country_code': 'VN',
    'phone_code': '84'
  },
  {
    'en-US': 'Vanuatu',
    'zh-CN': '瓦努阿图',
    'country_code': 'VU',
    'phone_code': '678'
  },
  {
    'en-US': 'Samoa',
    'zh-CN': '萨摩亚',
    'country_code': 'WS',
    'phone_code': '685'
  },
  {
    'en-US': 'Yemen',
    'zh-CN': '也门',
    'country_code': 'YE',
    'phone_code': '967'
  },
  {
    'en-US': 'Mayotte',
    'zh-CN': '马约特',
    'country_code': 'YT',
    'phone_code': '269'
  },
  {
    'en-US': 'South Africa',
    'zh-CN': '南非',
    'country_code': 'ZA',
    'phone_code': '27'
  },
  {
    'en-US': 'Zambia',
    'zh-CN': '赞比亚',
    'country_code': 'ZM',
    'phone_code': '260'
  },
  {
    'en-US': 'Zimbabwe',
    'zh-CN': '津巴布韦',
    'country_code': 'ZW',
    'phone_code': '263'
  }
]



// WEBPACK FOOTER //
// ./src/utils/country_code.js